import Vue from 'vue';

export default {

  name: 'organiser-accordion',

  props: {
    OrganiserIsVisible: false,
    organiser: {}
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/organiser/OrganiserAccordion/OrganiserAccordion.js